import { render, staticRenderFns } from "./JeecgOrderDMainList.vue?vue&type=template&id=5d2b31b0&scoped=true&"
import script from "./JeecgOrderDMainList.vue?vue&type=script&lang=js&"
export * from "./JeecgOrderDMainList.vue?vue&type=script&lang=js&"
import style0 from "./JeecgOrderDMainList.vue?vue&type=style&index=0&id=5d2b31b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2b31b0",
  null
  
)

export default component.exports